export const AmbientBackground = () => (
  <div className="fixed inset-0 grid-bg pointer-events-none z-0" />
);

export default AmbientBackground;
